<template>
	<tr :class="{ group }">
		<td class="icon collapse"><component v-if="icon" :is="icon" /></td>
		<td class="label">{{ label }}</td>
		<td class="value collapse">{{ value }}</td>
	</tr>
</template>

<script>
export default {
	name: 'EventStatsRow',
	props: {
		label: {
			type: String,
			required: true,
		},
		value: {
			required: true,
		},
		icon: Object,
	},
	computed: {
		group() {
			return this.icon != null
		},
	},
}
</script>

<style lang="scss" scoped>
@import '~scss/layout';

$pad: 0.75rem;

tr {
	@include not-last {
		padding-right: $pad;
	}

	&.group:not(:first-child) td {
		padding-top: $pad;
	}

	.icon {
		color: $col-primary;
	}

	.value {
		text-align: right;
		font-weight: bold;
	}

	.collapse {
		width: 0;
		white-space: nowrap;
	}
}
</style>
